var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","data-content-area":"1200px"}},[_c('AppLoader',{attrs:{"isHidden":!_vm.userInfo.loginInProcess}}),(!_vm.userInfo.isLoggedIn)?_c('AppLogin'):[_c('div',[_c('PageHeader'),_c('router-view')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }